// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36IWw","toggleWrap":"styles_toggleWrap__1rkil","content":"styles_content__YvWeR","selectAreaCode":"styles_selectAreaCode__1UoND"};